import { Link, useNavigate } from "react-router-dom";

import { Space, Breadcrumb, Card } from "antd";
import { PageHeader } from "@ant-design/pro-layout";

import {
  UserData,
} from "../../model/model";

import UserForm from "./UserForm";
import SessionStore from "../../model/SessionStore";

function CreateUser() {
  const navigate = useNavigate();

  const onFinish = (obj: UserData, password: string) => {
    SessionStore.getClient().createUser(obj, SessionStore.getBearer()).then(() => {
      navigate("/users");
    });
  };
  const userData :UserData= {
      login: '',
          email: '',
          name: '',
          role: '',
          pass: '',
          subId: '',
          orgId: '',
          siteId: '',
          lastSeenAt:0
    };
  return (
    <Space direction="vertical" style={{ width: "100%" }} size="large">
      <PageHeader
        breadcrumbRender={() => (
          <Breadcrumb>
            <Breadcrumb.Item>
              <span>Network-server</span>
            </Breadcrumb.Item>
            <Breadcrumb.Item>
              <span>
                <Link to="/users">Users</Link>
              </span>
            </Breadcrumb.Item>
            <Breadcrumb.Item>
              <span>Add</span>
            </Breadcrumb.Item>
          </Breadcrumb>
        )}
        title="Add user"
      />
      <Card>
        <UserForm initialValues={userData} onFinish={onFinish} password = {true} />
      </Card>
    </Space>
  );
}

export default CreateUser;
